export default "__VITE_ASSET__87f9cff4__"